import { CheckBallActiveIcon, CheckBallErrorIcon, CheckBallInactiveIcon } from 'lib/svgs/Icons';
import { FC, HTMLAttributes, PropsWithChildren } from 'react';

export type CheckBallStatus = 'active' | 'inactive' | 'error';

interface ICheckBallIcon extends HTMLAttributes<HTMLDivElement> {
  status?: CheckBallStatus;
}

const CheckBallIcon: FC<PropsWithChildren<ICheckBallIcon>> = ({ status }) => {
  if (status === 'active') return <CheckBallActiveIcon />;

  if (status === 'inactive') return <CheckBallInactiveIcon />;

  if (status === 'error') return <CheckBallErrorIcon />;

  return null;
};

export default CheckBallIcon;
